$(function () {
  // "View All" tab's groups
  $('.page-tabs .page-group-link').on('click', function () {
    $(this).parent().toggleClass('active')
  })
})
